import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import FileUpload from '../../fileUpload';
import { getFormFields, isFormValid, onTextChange, onDropDownChange, onEmailChange } from '../../../utile/formHelper';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import { FileAttachmentIcon, CrossInBox, AddIcon2 } from '../../svgIcons';
import './EditStudentInfo.scss';

// Import dropdown data
import castes from '../../../constants/castes.json';
import religions from '../../../constants/religions.json';
import states from '../../../constants/states.json';
import countryPhoneCodes from '../../../constants/countryPhoneCodes.json';
import countries from '../../../constants/countries.json';
import motherTongue from '../../../constants/motherTongue.json';
import gradesEnum from '../../../constants/grades.json';
import districts from '../../../constants/districts.json';

const createFields = require('./editStudentInfoComplete.json');

export default class EditStudentInfoNew extends Component {
    constructor(props) {
        super(props);

        // Transform dropdown data
        const transformedCountryPhoneCodes = countryPhoneCodes.map(country => ({
            label: `${country.country} (+${country.code})`,
            value: country.code
        }));

        const transformedMotherTongue = motherTongue.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        const transformedCastes = castes.map(caste => ({
            label: caste.label,
            value: caste.value
        }));

        const transformedReligions = religions.map(religion => ({
            label: religion.label,
            value: religion.value
        }));

        const transformedCountries = countries.map(country => ({
            label: country.name,
            value: country.code
        }));

        const transformedStates = states.map(state => ({
            label: state.label,
            value: state.value
        }));

        const transformedGrades = Object.entries(gradesEnum).map(([label, value]) => ({
            label: label,
            value: value
        }));

        this.formFields = getFormFields(createFields);

        const editData = this.props?.EditData?.user_info || {};

        // Initialize districts based on existing state
        let initialDistricts = [];
        if (editData.state && districts[editData.state]) {
            initialDistricts = districts[editData.state].map(district => ({
                label: district,
                value: district
            }));
        }

        // If cityOrDist value exists but not in the list, add it
        if (editData.cityOrDist && !initialDistricts.some(d => d.value === editData.cityOrDist)) {
            initialDistricts.push({
                label: editData.cityOrDist,
                value: editData.cityOrDist
            });
        }

        this.state = {
            isLoading: false,
            activeIndex: 0,
            formValidations: this.formFields?.formValidations,
            familyValidationError: false,
            siblingValidationError: false,
            firstNameError: '',
            lastNameError: '',
            studentInfo: {
                ...editData,
                dateOfBirth: editData.dateOfBirth ? new Date(editData.dateOfBirth) : null,
                idDetails: editData.idDetails || editData.aadharNo || '',
            },

            // Family data
            familyMembers: this.initializeFamilyMembers(editData),

            // Dropdown options
            countryPhoneCodes: transformedCountryPhoneCodes,
            motherTongue: transformedMotherTongue,
            castes: transformedCastes,
            religions: transformedReligions,
            countries: transformedCountries,
            statesData: transformedStates,
            gradesData: transformedGrades,
            cityOrDist: initialDistricts,

            // Static dropdowns
            genderOptions: [
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Other', value: 'other' }
            ],
            bloodGroupOptions: [
                { label: 'A+', value: 'A+' },
                { label: 'A-', value: 'A-' },
                { label: 'B+', value: 'B+' },
                { label: 'B-', value: 'B-' },
                { label: 'O+', value: 'O+' },
                { label: 'O-', value: 'O-' },
                { label: 'AB+', value: 'AB+' },
                { label: 'AB-', value: 'AB-' }
            ],
            relationTypes: [
                { label: 'Father', value: 'Father' },
                { label: 'Mother', value: 'Mother' },
                { label: 'Guardian', value: 'Guardian' },
                // { label: 'Brother', value: 'Brother' },
                // { label: 'Sister', value: 'Sister' }
            ],
            govtIdTypes: [
                { label: 'Aadhaar Card', value: 'aadhaar' },
                { label: 'Passport', value: 'passport' },
                { label: 'Other', value: 'other' }
            ]
        };

        this.service = new Service();
    }

    // Helper function to extract country code from contact number
    extractCountryCodeAndContact = (contactNumber) => {
        // Convert to string and handle null/undefined/empty values
        const contactStr = contactNumber ? String(contactNumber).trim() : '';
        
        if (!contactStr) return { countryCode: '', contact: '' };

        // Remove any spaces, hyphens, or other formatting
        let cleanedNumber = contactStr.replace(/[\s-]/g, '');

        // Remove + if present at the start
        if (cleanedNumber.startsWith('+')) {
            cleanedNumber = cleanedNumber.substring(1);
        }

        // Check if the number has more than 10 digits (likely has country code)
        if (cleanedNumber.length > 10) {
            // Extract country code (all digits before the last 10)
            const countryCode = cleanedNumber.substring(0, cleanedNumber.length - 10);
            const contact = cleanedNumber.substring(cleanedNumber.length - 10);
            return { countryCode, contact };
        }

        // If 10 digits or less, no country code
        return { countryCode: '', contact: cleanedNumber };
    };

    initializeFamilyMembers = (editData) => {
        const members = [];

        // Add parents if they exist in new structure
        if (editData.parents && Array.isArray(editData.parents) && editData.parents.length > 0) {
            editData.parents.forEach(parent => {
                const rawContact = parent.parentContact || parent.contact || '';
                const { countryCode, contact } = this.extractCountryCodeAndContact(rawContact);
                
                members.push({
                    type: 'parent',
                    relationType: parent.parentType || parent.relationType,
                    name: parent.parentName || parent.name || '',
                    qualification: parent.qualification || parent.parentQualification || '',
                    profession: parent.profession || parent.occupation || '',
                    countryCode: parent.countryCode || countryCode,
                    contact: contact,
                    email: parent.parentEmailId || parent.email || ''
                });
            });
        } else {
            // Handle legacy parent fields
            if (editData.fatherName || editData.fatherMobileNum || editData.fatherEmailId) {
                const rawContact = editData.fatherMobileNum || '';
                const { countryCode, contact } = this.extractCountryCodeAndContact(rawContact);
                
                members.push({
                    type: 'parent',
                    relationType: 'Father',
                    name: editData.fatherName || '',
                    qualification: editData.fatherQualification || '',
                    profession: editData.fatherOccupation || '',
                    countryCode: editData.fatherCountryCode || countryCode,
                    contact: contact,
                    email: editData.fatherEmailId || ''
                });
            }

            if (editData.motherName || editData.motherMobileNum || editData.motherEmailId) {
                const rawContact = editData.motherMobileNum || '';
                const { countryCode, contact } = this.extractCountryCodeAndContact(rawContact);
                
                members.push({
                    type: 'parent',
                    relationType: 'Mother',
                    name: editData.motherName || '',
                    qualification: editData.motherQualification || '',
                    profession: editData.motherOccupation || '',
                    countryCode: editData.motherCountryCode || countryCode,
                    contact: contact,
                    email: editData.motherEmailId || ''
                });
            }

            if (editData.guardianName || editData.guardianMobileNum || editData.guardianEmailId) {
                const rawContact = editData.guardianMobileNum || '';
                const { countryCode, contact } = this.extractCountryCodeAndContact(rawContact);
                
                members.push({
                    type: 'parent',
                    relationType: 'Guardian',
                    name: editData.guardianName || '',
                    qualification: editData.guardianQualification || '',
                    profession: editData.guardianOccupation || '',
                    countryCode: editData.guardianCountryCode || countryCode,
                    contact: contact,
                    email: editData.guardianEmailId || ''
                });
            }
        }

        // Add siblings if they exist
        if (editData.siblings && Array.isArray(editData.siblings)) {
            editData.siblings.forEach(sibling => {
                members.push({
                    ...sibling,
                    type: 'sibling',
                    relationType: sibling.relationType || 'Sibling'
                });
            });
        }

        // If no parent members found, add one default parent entry with contactPersonName and parentContactNo
        const parentMembers = members.filter(m => m.type === 'parent');
        if (parentMembers.length === 0) {
            const rawContact = editData.parentContactNo || '';
            const { countryCode, contact } = this.extractCountryCodeAndContact(rawContact);
            
            members.unshift({
                type: 'parent',
                relationType: '',
                name: editData.contactPersonName || '',
                gender: '',
                qualification: '',
                profession: '',
                countryCode: countryCode,
                contact: contact,
                email: editData.email || ''
            });
        }

        return members;
    };

    componentDidMount() {
        // Component mounted
    }

    // File upload handlers
    _onProgress = (filesInfo) => { };

    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Error', detail: errMsg, life: 3000 });
    };

    _onPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    };

    _afterFilesUploaded = (files) => { };

    addAttachment = (fieldName, fileName, data) => {
        this.setState((prevState) => ({
            studentInfo: {
                ...prevState.studentInfo,
                [fieldName]: {
                    fileName,
                    storageBucket: data.Bucket,
                    storageKey: data.Key,
                    storageLocation: data.Location
                }
            }
        }));
    };

    onSimpleFieldChange = (field, value) => {
        this.setState(prevState => ({
            studentInfo: { ...prevState.studentInfo, [field]: value }
        }));
    };

    // Family members management
    addFamilyMember = (type) => {
        const newMember = {
            type,
            relationType: type === 'parent' ? '' : 'Sibling',
            name: '',
            gender: '',
            qualification: type === 'parent' ? '' : undefined,
            profession: type === 'parent' ? '' : undefined,
            classStudying: type === 'sibling' ? '' : undefined,
            schoolStudying: type === 'sibling' ? '' : undefined,
            countryCode: '',
            contact: '',
            email: ''
        };

        this.setState(prevState => ({
            familyMembers: [...prevState.familyMembers, newMember]
        }));
    };

    removeFamilyMember = (index) => {
        this.setState(prevState => ({
            familyMembers: prevState.familyMembers.filter((_, i) => i !== index)
        }));
    };

    updateFamilyMember = (index, field, value) => {
        this.setState(prevState => ({
            familyMembers: prevState.familyMembers.map((member, i) =>
                i === index ? { ...member, [field]: value } : member
            ),
            // Clear family validation errors when user starts typing
            familyValidationError: false,
            siblingValidationError: false
        }));
    };

    // Email validation helper
    isValidEmail = (email) => {
        if (!email || !email.trim()) return true; // Empty is valid (not required)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email.trim());
    };

    // Name validation helper
    validateName = (field, value) => {
        const trimmedValue = value?.trim() || '';
        const errorField = field === 'firstName' ? 'firstNameError' : 'lastNameError';
        
        if (trimmedValue && trimmedValue.length < 3) {
            this.setState({ [errorField]: 'Minimum 3 characters required' });
        } else {
            this.setState({ [errorField]: '' });
        }
        
        this.onSimpleFieldChange(field, value);
    };

    // Handle state selection and filter districts
    onStateChange = (selectedState) => {
        // Get districts for selected state from districts.json
        const stateDistricts = districts[selectedState] || [];

        // Transform districts to dropdown format
        let transformedDistricts = stateDistricts.map(district => ({
            label: district,
            value: district
        }));

        // If no districts found for the selected state, add "Other" option
        if (transformedDistricts.length === 0) {
            transformedDistricts = [{ label: 'Other', value: 'Other' }];
        }

        // Update state with filtered districts and reset city/district selection
        this.setState(prevState => ({
            cityOrDist: transformedDistricts,
            studentInfo: {
                ...prevState.studentInfo,
                state: selectedState,
                cityOrDist: '' // Reset district selection when state changes
            }
        }), () => {
            // Call the standard form validation after state update
            onDropDownChange(
                selectedState,
                'state',
                this,
                createFields,
                this.state.studentInfo,
                this.state.formValidations,
                'studentInfo',
                'formValidations'
            );
        });
    };

    // Save student info
    saveStudentInfo = async () => {
        const user_id = this.props?.EditData?.user_id;
        this.setState({ isLoading: true });

        // Validate first name and last name minimum length
        const firstName = this.state.studentInfo.firstName?.trim() || '';
        const lastName = this.state.studentInfo.lastName?.trim() || '';
        
        if (firstName && firstName.length < 3) {
            this.setState({ isLoading: false, firstNameError: 'Minimum 3 characters required' });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Student First Name must be at least 3 characters',
                life: 4000
            });
            return;
        }
        
        if (lastName && lastName.length < 3) {
            this.setState({ isLoading: false, lastNameError: 'Minimum 3 characters required' });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Student Last Name must be at least 3 characters',
                life: 4000
            });
            return;
        }

        // Helper function to check if a parent record is empty
        const isParentEmpty = (parent) => {
            return !parent.relationType && !parent.name && !parent.qualification && 
                   !parent.profession && !parent.countryCode && !parent.contact && !parent.email;
        };

        // Helper function to check if a sibling record is empty
        const isSiblingEmpty = (sibling) => {
            return !sibling.name && !sibling.gender && !sibling.classStudying && 
                   !sibling.schoolStudying && !sibling.countryCode && !sibling.contact && !sibling.email;
        };

        // Separate parents and siblings from family members, filtering out empty records
        const parents = this.state.familyMembers
            .filter(m => m.type === 'parent')
            .map(({ type, ...rest }) => ({
                parentType: rest.relationType,
                parentName: rest.name,
                qualification: rest.qualification,
                profession: rest.profession,
                countryCode: rest.countryCode,
                parentContact: rest.contact,
                parentEmailId: rest.email,
                relationType: rest.relationType
            }))
            .filter(parent => !(
                !parent.parentType && !parent.parentName && !parent.qualification && 
                !parent.profession && !parent.countryCode && !parent.parentContact && !parent.parentEmailId
            ));

        const siblings = this.state.familyMembers
            .filter(m => m.type === 'sibling')
            .map(({ type, ...rest }) => rest)
            .filter(sibling => !isSiblingEmpty(sibling));

        // Validate that at least one parent has minimum required data
        const hasValidParent = this.state.familyMembers
            .filter(m => m.type === 'parent')
            .some(parent => parent.name && parent.contact);

        if (!hasValidParent) {
            this.setState({ isLoading: false, familyValidationError: true });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'At least one parent with Name and Contact Number is required',
                life: 4000
            });
            return;
        }

        // Validate parents: if any parent details are provided, Name must be filled
        const parentsWithData = this.state.familyMembers.filter(m => m.type === 'parent');
        const invalidParents = parentsWithData.filter(parent => {
            const hasName = parent.name && typeof parent.name === 'string' && parent.name.trim();
            const hasOtherData = parent.relationType || parent.qualification || parent.profession || 
                                parent.countryCode || parent.contact || parent.email;
            // If other data is provided without name, it's invalid
            return hasOtherData && !hasName;
        });

        if (invalidParents.length > 0) {
            this.setState({ isLoading: false, familyValidationError: true });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Parent Name is required when providing parent details',
                life: 4000
            });
            return;
        }

        // Validate parent email addresses
        const parentsWithInvalidEmail = parentsWithData.filter(parent => {
            return parent.email && !this.isValidEmail(parent.email);
        });

        if (parentsWithInvalidEmail.length > 0) {
            this.setState({ isLoading: false, familyValidationError: true });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please enter a valid email address for parent/guardian',
                life: 4000
            });
            return;
        }

        // Validate siblings: if any sibling has data, Name and Gender are mandatory
        const siblingsWithData = this.state.familyMembers.filter(m => m.type === 'sibling');
        const invalidSiblings = siblingsWithData.filter(sibling => {
            // Check if any field has data
            const hasName = sibling.name && typeof sibling.name === 'string' && sibling.name.trim();
            const hasGender = sibling.gender;
            const hasOtherData = sibling.classStudying || sibling.schoolStudying || sibling.contact || sibling.email;
            
            // If name is provided without gender, or gender is provided without name, it's invalid
            // Also if other data is provided without both name and gender
            const nameWithoutGender = hasName && !hasGender;
            const genderWithoutName = hasGender && !hasName;
            const otherDataWithoutRequired = hasOtherData && (!hasName || !hasGender);
            
            return nameWithoutGender || genderWithoutName || otherDataWithoutRequired;
        });

        if (invalidSiblings.length > 0) {
            this.setState({ isLoading: false, siblingValidationError: true });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Sibling Name and Gender are required when providing sibling details',
                life: 4000
            });
            return;
        }

        // Validate student email address
        if (this.state.studentInfo.stdEmailId && !this.isValidEmail(this.state.studentInfo.stdEmailId)) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please enter a valid student email address',
                life: 4000
            });
            return;
        }

        const payload = {
            user_info: {
                ...this.state.studentInfo,
                parents,
                siblings
            },
            user_id
        };

        try {
            const url = `${baseUrlAdmin}/user/editUserInfo`;
            const res = await this.service.post(url, payload, true);

            if (res && res.status) {
                this.setState({ isLoading: false });
                this.props.isShowEditForm();
                this.props.filterUsersData();
                this.toast.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Student information updated successfully',
                    life: 3000
                });
            } else {
                throw new Error(res.errMessage || 'Failed to update');
            }
        } catch (err) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: err.message || 'Failed to update student information',
                life: 3000
            });
        }
    };

    // Render methods for each tab
    renderAcademicDetails = () => {
        const { studentInfo, formValidations } = this.state;

        return (
            <div className="edit-student-form-section">
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetInputText
                            label="Enrollment ID"
                            // required={true}
                            height="48px"
                            value={studentInfo.enrollmentId || ''}
                            placeholder="Enrollment ID"
                            disabled={true}
                            onChange={(e) => onTextChange(e.target.value, 'enrollmentId', this, createFields, studentInfo, formValidations, 'studentInfo', 'formValidations')}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetDropdown
                            label="Branch"
                            // required={true}
                            height="48px"
                            options={[{ label: studentInfo.branchName, value: studentInfo.branchId }]}
                            value={studentInfo.branchId || ''}
                            placeholder="Select Branch"
                            disabled={true}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetDropdown
                            label="Board"
                            // required={true}
                            height="48px"
                            options={[{ label: studentInfo['custom:board'], value: studentInfo['custom:board'] }]}
                            value={studentInfo['custom:board'] || ''}
                            placeholder="Select Board"
                            disabled={true}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetDropdown
                            label="Class/Grade"
                            // required={true}
                            height="48px"
                            options={[{ label: studentInfo['custom:grade'], value: studentInfo['custom:grade'] }]}
                            value={studentInfo['custom:grade'] || ''}
                            placeholder="Select Class"
                            disabled={true}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetDropdown
                            label="Section"
                            // required={true}
                            height="48px"
                            options={[{ label: studentInfo.sectionName, value: studentInfo.sectionName }]}
                            value={studentInfo.sectionName || ''}
                            placeholder="Select Section"
                            disabled={true}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetDropdown
                            label="Admission Category"
                            height="48px"
                            options={[{ label: studentInfo.categoryName, value: studentInfo.categoryName }]}
                            value={studentInfo.categoryName || ''}
                            placeholder="Admission Category"
                            disabled={true}
                        />
                    </div>

                    

                    <div className="col-12 md:col-6 lg:col-3">
                        <ClassetInputText
                            label="RFID"
                            height="48px"
                            value={studentInfo.rfid || ''}
                            placeholder="RFID"
                            onChange={(e) => onTextChange(e.target.value, 'rfid', this, createFields, studentInfo, formValidations, 'studentInfo', 'formValidations')}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderPersonalDetails = () => {
        const { studentInfo, formValidations, genderOptions, bloodGroupOptions, motherTongue, castes, religions, govtIdTypes, countryPhoneCodes, countries } = this.state;

        return (
            <div className="edit-student-form-section">
                <div className="family-section-header mb-4">
                    <h3>Personal Details</h3>
                </div>

                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Student First Name"
                            // required={true}
                            height="48px"
                            value={studentInfo.firstName || ''}
                            placeholder="Student First Name"
                            onChange={(e) => this.validateName('firstName', e.target.value)}
                            className={this.state.firstNameError ? 'p-invalid' : ''}
                        />
                        {this.state.firstNameError && (
                            <small className="p-error">{this.state.firstNameError}</small>
                        )}
                        {formValidations && !formValidations.fields['firstName']?.isValid && (
                            <p className="p-error">{formValidations.fields['firstName']?.errorMsg}</p>
                        )}
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Student Middle Name"
                            height="48px"
                            value={studentInfo.middleName || ''}
                            placeholder="Student Middle Name"
                            onChange={(e) => this.onSimpleFieldChange('middleName', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Student Last Name"
                            // required={true}
                            height="48px"
                            value={studentInfo.lastName || ''}
                            placeholder="Student Last Name"
                            onChange={(e) => this.validateName('lastName', e.target.value)}
                            className={this.state.lastNameError ? 'p-invalid' : ''}
                        />
                        {this.state.lastNameError && (
                            <small className="p-error">{this.state.lastNameError}</small>
                        )}
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Gender"
                            // required={true}
                            height="48px"
                            options={genderOptions}
                            value={studentInfo.gender || ''}
                            placeholder="Select Gender"
                            onChange={(e) => this.onSimpleFieldChange('gender', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetCalendar
                            label="Date of Birth"
                            // required={true}
                            height="48px"
                            placeholder="DOB"
                            calendarMode="single"
                            value={studentInfo.dateOfBirth}
                            onChange={(e) => this.onSimpleFieldChange('dateOfBirth', e.value)}
                            maxDate={new Date()}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <label className="" style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px', display: 'block' }}>
                            Upload Photo
                        </label>
                        <FileUpload
                            id={'studentPhoto'}
                            multiple={false}
                            onProgress={this._onProgress}
                            onSucess={this._onPhotoSuccess}
                            maxFileSize={307200}
                            onError={this._onFilsUploadError}
                            accept={'images'}
                            title={'Images'}
                            afterFilesUploaded={this._afterFilesUploaded}
                        >
                            <div className="flex items-center">
                                <ClassetInputText
                                    width={'100%'}
                                    icon={<FileAttachmentIcon width={20} height={24} color={'black'} />}
                                    value={studentInfo.studentPhoto?.fileName || ''}
                                    placeholder="Upload Photo"
                                    disabled={true}
                                />
                                {studentInfo.studentPhoto?.storageLocation && (
                                    <div className="ml-2">
                                        <img
                                            src={studentInfo.studentPhoto?.storageLocation}
                                            alt="Student"
                                            width={50}
                                            height={50}
                                            style={{ borderRadius: '4px', objectFit: 'cover' }}
                                        />
                                    </div>
                                )}
                            </div>
                        </FileUpload>
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Nationality"
                            height="48px"
                            options={countries}
                            value={studentInfo.nationality || ''}
                            placeholder="Select Nationality"
                            filter
                            onChange={(e) => this.onSimpleFieldChange('nationality', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Govt ID"
                            height="48px"
                            options={govtIdTypes}
                            value={studentInfo.govtIdType || ''}
                            placeholder="Select Govt ID"
                            onChange={(e) => this.onSimpleFieldChange('govtIdType', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="ID Details"
                            height="48px"
                            value={studentInfo.idDetails || ''}
                            placeholder="Enter ID Details"
                            onChange={(e) => this.onSimpleFieldChange('idDetails', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Religion"
                            height="48px"
                            options={religions}
                            value={studentInfo.religion || ''}
                            placeholder="Select Religion"
                            onChange={(e) => this.onSimpleFieldChange('religion', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Mother Tongue"
                            height="48px"
                            value={studentInfo.motherTongue || ''}
                            placeholder="Enter Language"
                            onChange={(e) => this.onSimpleFieldChange('motherTongue', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Caste"
                            height="48px"
                            options={castes}
                            value={studentInfo.caste || ''}
                            placeholder="Select Caste"
                            filter
                            onChange={(e) => this.onSimpleFieldChange('caste', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Country Code"
                            height="48px"
                            options={countryPhoneCodes}
                            value={studentInfo.stdCountryCode || ''}
                            placeholder="Select Country Phone Code"
                            filter
                            onChange={(e) => this.onSimpleFieldChange('stdCountryCode', e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Contact No"
                            height="48px"
                            value={studentInfo.stdContactNo || ''}
                            placeholder="Contact no"
                            keyfilter="pint"
                            maxLength={10}
                            onChange={(e) => this.onSimpleFieldChange('stdContactNo', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Email ID"
                            height="48px"
                            value={studentInfo.stdEmailId || ''}
                            placeholder="Email ID"
                            onChange={(e) => this.onSimpleFieldChange('stdEmailId', e.target.value)}
                            className={studentInfo.stdEmailId && !this.isValidEmail(studentInfo.stdEmailId) ? 'p-invalid' : ''}
                        />
                        {studentInfo.stdEmailId && !this.isValidEmail(studentInfo.stdEmailId) && (
                            <small className="p-error">Please enter a valid email address</small>
                        )}
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Current Location"
                            height="48px"
                            value={studentInfo.currentLocation || ''}
                            placeholder="Enter Current Location"
                            onChange={(e) => this.onSimpleFieldChange('currentLocation', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="Blood Group"
                            height="48px"
                            options={bloodGroupOptions}
                            value={studentInfo.bloodGroup || ''}
                            placeholder="Select Blood Group"
                            onChange={(e) => this.onSimpleFieldChange('bloodGroup', e.value)}
                        />
                    </div>

                    <div className="col-12">
                        <ClassetTextArea
                            label="Identification Marks"
                            height="100px"
                            value={studentInfo.identificationMarks || ''}
                            placeholder="Enter Identification Marks"
                            onChange={(e) => this.onSimpleFieldChange('identificationMarks', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderFamilyDetails = () => {
        const { familyMembers, formValidations, countryPhoneCodes, genderOptions, gradesData, familyValidationError, siblingValidationError } = this.state;

        const parents = familyMembers.filter(m => m.type === 'parent');
        const siblings = familyMembers.filter(m => m.type === 'sibling');

        // Check if any parent has minimum data (for showing validation message)
        const hasAnyParentData = parents.some(p => p.name || p.contact || p.relationType || p.email);

        return (
            <div className="edit-student-form-section">
                {/* Parent Details Section */}
                <div className="family-section-header mb-4 flex align-items-center justify-content-between">
                    <h3>Parent Details</h3>
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-primary"
                        style={{ width: '48px', height: '48px' }}
                        onClick={() => this.addFamilyMember('parent')}
                        tooltip="Add Another Parent"
                    />
                </div>

                {familyValidationError && (
                    <div className="mb-3 p-3" style={{ background: '#FEE2E2', border: '1px solid #EF4444', borderRadius: '6px' }}>
                        <p className="p-error mb-0" style={{ fontSize: '14px' }}>
                            <i className="pi pi-exclamation-triangle mr-2"></i>
                            At least one parent with Name and Contact Number is required
                        </p>
                    </div>
                )}

                {parents.map((parent, index) => {
                    const actualIndex = familyMembers.findIndex(m => m === parent);
                    const hasName = parent.name && typeof parent.name === 'string' && parent.name.trim();
                    const hasOtherData = parent.relationType || parent.qualification || parent.profession || 
                                        parent.countryCode || parent.contact || parent.email;
                    const isParentEmpty = !parent.name && !parent.contact;
                    const showError = familyValidationError && (isParentEmpty || (hasOtherData && !hasName));
                    
                    return (
                        <div key={`parent-${index}`} className="family-member-card mb-4 p-4" style={{ 
                            background: '#F9FAFB', 
                            borderRadius: '8px', 
                            border: showError ? '2px solid #EF4444' : '1px solid #E5E7EB' 
                        }}>
                            <div className="grid">
                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetDropdown
                                        label="Relationship"
                                        height="48px"
                                        options={[
                                            { label: 'Father', value: 'Father' },
                                            { label: 'Mother', value: 'Mother' },
                                            { label: 'Guardian', value: 'Guardian' }
                                        ]}
                                        value={parent.relationType || ''}
                                        placeholder="Select Relationship"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'relationType', e.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Parent Name"
                                        height="48px"
                                        value={parent.name || ''}
                                        placeholder="Enter Parent Name"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'name', e.target.value)}
                                        className={showError && !hasName ? 'p-invalid' : ''}
                                    />
                                    {showError && !hasName && (
                                        <small className="p-error">Name is required</small>
                                    )}
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Qualification"
                                        height="48px"
                                        value={parent.qualification || ''}
                                        placeholder="Enter Qualification"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'qualification', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Profession"
                                        height="48px"
                                        value={parent.profession || ''}
                                        placeholder="Enter Profession"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'profession', e.target.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetDropdown
                                        label="Country Code"
                                        height="48px"
                                        options={countryPhoneCodes}
                                        value={parent.countryCode || ''}
                                        placeholder="Select Country Code"
                                        filter
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'countryCode', e.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Parent/Guardian Contact No."
                                        height="48px"
                                        value={parent.contact || ''}
                                        placeholder="Enter Contact Number"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'contact', e.target.value)}
                                        className={showError && !parent.contact ? 'p-invalid' : ''}
                                    />
                                    {showError && !parent.contact && (
                                        <small className="p-error">Contact is required</small>
                                    )}
                                    
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Parent/Guardian Email ID"
                                        // required={true}
                                        height="48px"
                                        value={parent.email || ''}
                                        placeholder="Enter Email ID"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'email', e.target.value)}
                                        className={parent.email && !this.isValidEmail(parent.email) ? 'p-invalid' : ''}
                                    />
                                    {parent.email && !this.isValidEmail(parent.email) && (
                                        <small className="p-error">Please enter a valid email address</small>
                                    )}
                                </div>

                                <div className="col-12 md:col-6 lg:col-3 flex align-items-end">

                                    {parents.length > 1 && (
                                        <Button
                                            icon="pi pi-trash"
                                            className="p-button-rounded p-button-danger ml-2"
                                            style={{ width: '48px', height: '48px' }}
                                            onClick={() => this.removeFamilyMember(actualIndex)}
                                            tooltip="Remove Parent"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}

                {/* Siblings Section */}
                <div className="family-section-header mb-4 mt-5 flex align-items-center justify-content-between">
                    <h3>Siblings</h3>
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-primary"
                        style={{ width: '48px', height: '48px' }}
                        onClick={() => this.addFamilyMember('sibling')}
                        tooltip="Add Another Sibling"
                    />
                </div>

                {siblingValidationError && (
                    <div className="mb-3 p-3" style={{ background: '#FEE2E2', border: '1px solid #EF4444', borderRadius: '6px' }}>
                        <p className="p-error mb-0" style={{ fontSize: '14px' }}>
                            <i className="pi pi-exclamation-triangle mr-2"></i>
                            Sibling Name and Gender are required when providing sibling details
                        </p>
                    </div>
                )}

                {siblings.map((sibling, index) => {
                    const actualIndex = familyMembers.findIndex(m => m === sibling);
                    const hasName = sibling.name && typeof sibling.name === 'string' && sibling.name.trim();
                    const hasGender = sibling.gender;
                    const hasOtherData = sibling.classStudying || sibling.schoolStudying || sibling.contact || sibling.email;
                    const showError = siblingValidationError && ((hasName && !hasGender) || (hasGender && !hasName) || (hasOtherData && (!hasName || !hasGender)));
                    
                    return (
                        <div key={`sibling-${index}`} className="family-member-card mb-4 p-4" style={{ 
                            background: '#F9FAFB', 
                            borderRadius: '8px', 
                            border: showError ? '2px solid #EF4444' : '1px solid #E5E7EB' 
                        }}>
                            <div className="grid">
                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="Name"
                                        height="48px"
                                        value={sibling.name || ''}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'name', e.target.value)}
                                        className={showError && !(sibling.name && typeof sibling.name === 'string' && sibling.name.trim()) ? 'p-invalid' : ''}
                                    />
                                    {showError && !(sibling.name && typeof sibling.name === 'string' && sibling.name.trim()) && (
                                        <small className="p-error">Name is required</small>
                                    )}
                                </div>

                                <div className="col-6 md:col-3 lg:col-2">
                                    <ClassetDropdown
                                        label="Gender"
                                        height="48px"
                                        options={genderOptions}
                                        value={sibling.gender || ''}
                                        placeholder="Select Gender"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'gender', e.value)}
                                        className={showError && !sibling.gender ? 'p-invalid' : ''}
                                    />
                                    {showError && !sibling.gender && (
                                        <small className="p-error">Gender is required</small>
                                    )}
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetDropdown
                                        label="Class Studying"
                                        height="48px"
                                        options={gradesData}
                                        value={sibling.classStudying || ''}
                                        placeholder="Select Class"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'classStudying', e.value)}
                                    />
                                </div>

                                <div className="col-12 md:col-6 lg:col-3">
                                    <ClassetInputText
                                        label="School Studying"
                                        height="48px"
                                        value={sibling.schoolStudying || ''}
                                        placeholder="Enter School Studying"
                                        onChange={(e) => this.updateFamilyMember(actualIndex, 'schoolStudying', e.target.value)}
                                    />

                                </div>
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-danger ml-2"
                                    style={{ width: '48px', height: '48px' }}
                                    onClick={() => this.removeFamilyMember(actualIndex)}
                                    tooltip="Remove Sibling"
                                />

                                {/* <div className="col-12 md:col-6 lg:col-3">
                                    
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-danger ml-2"
                                        style={{ width: '48px', height: '48px' }}
                                        onClick={() => this.removeFamilyMember(actualIndex)}
                                        tooltip="Remove Sibling"
                                    />
                                </div> */}
                            </div>
                        </div>
                    );
                })}

                {siblings.length === 0 && (
                    <div className="text-center py-4">
                        <p className="text-gray-500 mb-3">No siblings added</p>
                        <Button
                            label="Add Sibling"
                            icon="pi pi-plus"
                            className="p-button-outlined"
                            onClick={() => this.addFamilyMember('sibling')}
                        />
                    </div>
                )}
            </div>
        );
    };

    renderAddress = () => {
        const { studentInfo, formValidations, statesData, countries } = this.state;

        return (
            <div className="edit-student-form-section">
                <div className="family-section-header mb-4">
                    <h3>Address</h3>
                </div>

                <div className="grid">
                    <div className="col-12">
                        <ClassetInputText
                            label="Address Line"
                            // required={true}
                            height="48px"
                            width="95%"
                            value={studentInfo.addressLine || ''}
                            placeholder="Enter Address"
                            onChange={(e) => this.onSimpleFieldChange('addressLine', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetInputText
                            label="Pincode"
                            // required={true}
                            height="48px"
                            value={studentInfo.pinCode || ''}
                            placeholder="Enter Pincode"
                            keyfilter="pint"
                            minLength={6}
                            maxLength={6}
                            onChange={(e) => this.onSimpleFieldChange('pinCode', e.target.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="State"
                            // required={true}
                            height="48px"
                            options={statesData}
                            value={studentInfo.state || ''}
                            placeholder="Select State"
                            filter
                            onChange={(e) => this.onStateChange(e.value)}
                        />
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <ClassetDropdown
                            label="City/District"
                            // required={true}
                            height="48px"
                            options={this.state.cityOrDist}
                            value={studentInfo.cityOrDist || ''}
                            placeholder="Select City/District"
                            filter
                            onChange={(e) => this.onSimpleFieldChange('cityOrDist', e.value)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { studentInfo, isLoading, activeIndex } = this.state;
        const studentName = `${studentInfo.firstName || ''} ${studentInfo.lastName || ''}`.trim() || 'Student';
        const enrollmentId = studentInfo.enrollmentId || '';

        return (
            <div className="edit-student-container">
                <div className="edit-student-header  flex align-items-center justify-content-between">
                    <h2 className="edit-student-title" style={{ fontSize: '1.5rem', fontWeight: '600' }}>
                        {studentName}
                    </h2>
                    <h2 className="edit-student-title" style={{ fontSize: '1.5rem', fontWeight: '600' }}>
                        {enrollmentId}
                    </h2>
                </div>

                <TabView
                    activeIndex={activeIndex}
                    onTabChange={(e) => this.setState({ activeIndex: e.index })}
                    className="edit-student-tabs"
                >
                    <TabPanel header="Academic Details">
                        {this.renderAcademicDetails()}
                    </TabPanel>

                    <TabPanel header="Personal Details">
                        {this.renderPersonalDetails()}
                    </TabPanel>

                    <TabPanel header="Family Details">
                        {this.renderFamilyDetails()}
                    </TabPanel>

                    <TabPanel header="Address">
                        {this.renderAddress()}
                    </TabPanel>
                </TabView>

                <div className="edit-student-footer">
                    <Button
                        label="Save"
                        className="p-button-primary edit-student-save-btn"
                        onClick={this.saveStudentInfo}
                        disabled={isLoading}
                    />
                    <Button
                        label="Cancel"
                        className="p-button-secondary edit-student-cancel-btn"
                        onClick={() => this.props.isShowEditForm()}
                        disabled={isLoading}
                    />
                </div>

                {isLoading && <LoadingComponent />}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}
